import GilroyWhiteSvg from 'Components/common/assets/svgIcons/GilroyWhiteSvg';
import SmartPlanSvg from 'Components/common/assets/svgIcons/SmartPlanSvg';
import {
  selectAccountPlanHistory,
  selectAccountPlanHistoryLoading,
  selectAccountPlanUrl,
  selectCompanyProfile, selectDownloadUrl, selectGeneratedAccountPlans,
  selectLatestHistoryId,
  selectPreviewUrl,
} from 'Selector/CompaniesSelector';
import { FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS, SMART_POPUP_TITLE } from 'Utils/Constants';
import {
  SmartAccountHeadingText, backgroundGreenLayer, maxTablet,
  maxWidth, primaryColor, primaryFont, retina, wMBold,
} from 'Utils/utilsStyle';
import { Divider, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions } from 'Slice/CompaniesSlice';
import { actions as helperActions } from 'Slice/HelperSlice';
import { EmailShareButton } from 'react-share';
import {
  IsMobileSm, MinWidthApp, getCurrentTime, valueToObject,
} from 'Utils/UtilityFunctions';
import classNames from 'classnames';
import Preview from 'Pages/document/DrawerDocViewer';
import PreviewDocIcon from 'Components/common/assets/svgIcons/PreviewDocIcon';
import ShareIcon from 'Components/common/assets/svgIcons/ShareIcon';
import SaveIcon from 'Components/common/assets/svgIcons/SaveIcon';
import CreateNewSapBtn from './CreateNewSapBtn';

const Wrapper = styled.div`
&.smartHistoryStyle {
  height: unset;
  padding-top: 48px;
  padding-bottom: 23px;
  .smart-plan-svg {
    margin-bottom: 20px;
  }
  .smart-document-heading {
    margin-bottom: 26px;
  }
  .download-btn {
    margin-top: 16px;
  }
  .create-new-smart-plan {
    display: none;
  }
}
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
  padding: 0 60px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 0px 24px;
  }
  @media all and (max-width: ${maxTablet}) {
    padding: 0px 10px;
  }
  .smart-plan-svg {
    width: 82px;
    height: 82px;
    margin-bottom: 33px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 75px;
      height: 75px;
      margin-bottom: 14px;
    }
  }
  .smart-document-heading {
    ${SmartAccountHeadingText};
    margin-bottom: 40px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin-bottom: 25px;
    }
    sup {
      font-size: 17px;
      top: -12px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 13px;
        top: -10px;
      }
    }
  }
  .smart-btn-div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .smart-btn {
      font-family: ${primaryFont} !important;
      font-weight: ${wMBold} !important;
      font-size: 16px !important;
      line-height: 25px !important;
      color: ${primaryColor} !important;
      cursor: pointer !important;
      min-width: 60px;
      @media all and (max-width: ${maxWidth}) and (${retina}) {
        font-size: 14px !important;
        line-height: 20px !important;
      }
      .share-btn-smart {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .shareIcon-svg {
        position: absolute;
        height: 16px;
        width: 12px;
        right: 42px;
        top: 3px;
        }
      }
      svg {
        margin-right: 6px;
      }
      &.preview {
      }
    }
    .ant-divider {
      border-left: 1px solid #979797;
      margin: 0 16px;
    }
  .download-btn {
    display: flex;
    align-items: center;
    font-family: ${primaryFont};
    font-weight: ${wMBold};
    font-size: 16px;
    line-height: 25px;
    border-radius: 23px;
    height: 36px;
    color: #fff;
    background-color: ${primaryColor};
    padding: 4px 16px 4px 13px;
    margin-top: 19px;
    cursor: pointer;
    svg {
      margin-right: 6px;
    }
  }
  .ant-modal-root {
    .ant-modal-mask {
      position: absolute;
      left: 0;
      right: 0;
    }
    .ant-modal-wrap {
      position: absolute;
      left: 0;
      right: 0;
    }
  }
`;
const SmartModal = styled(Modal)`
.ant-modal-content {
  background-image: url(${backgroundGreenLayer});
  background-position: center;
  background-size: 106% 106%;
  .ant-modal-close {
    display: none;
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding:0px 23px;
    @media all and (max-width: ${maxWidth}),${retina} {
      padding: 37px 34px 0;
    }
    padding-top: 37px;
    .gilroy-white-svg {
      width: 80px;
      height: 80px;
    }
    .popup-heading {
      ${SmartAccountHeadingText};
      font-size: 21px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}),${retina} {
        font-size: 20px;
        line-height: 24px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
  .ant-modal-footer {
    padding: 23px 10px 36px;
    .ant-btn {
      border-radius: 23px;
      border: 1.6px solid ${primaryColor};
      font-family: ${primaryFont};
      @media all and (max-width: ${maxWidth}),${retina} {
        font-size: 14px;
        line-height: 16px;
        min-width: 85px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
}
`;

type Props = {
  companyId: number
  handleNewAccountPlan: () => void,
  showAccountReadyScreen?: boolean,
  handleAllowPop?: () => void,
  drawerOpen: boolean,
  setDrawerOpen: (a: boolean) => void,
} & typeof defaultProps;

const defaultProps = {
  showAccountReadyScreen: false,
  handleAllowPop: () => { },
};

const SmartPlanDocumentReady = function SmartPlanDocumentReady(props: Props) {
  const {
    companyId, handleNewAccountPlan, drawerOpen, setDrawerOpen, showAccountReadyScreen,
    handleAllowPop,
  } = props;
  const dispatch = useDispatch();
  const startTime = getCurrentTime();
  const [showPopup, setShowPopup] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');
  const [sapDocumentId, setSapDocumentId] = useState(0);
  const [isShareOperation, setIsShareOperation] = useState(false);
  const url = useSelector(selectAccountPlanUrl);
  const generatedAccountPlans = useSelector(selectGeneratedAccountPlans);
  const companyProfile = useSelector(selectCompanyProfile);
  const downloadAPIUrl = useSelector(selectDownloadUrl);
  const previewAPIUrl = useSelector(selectPreviewUrl);

  const isTab = MinWidthApp();
  const isSmMob = IsMobileSm();
  const latestHistoryId = useSelector(selectLatestHistoryId);

  useEffect(() => {
    generatedAccountPlans.forEach((plan) => {
      if (plan.companyId === companyId) {
        dispatch(actions.setUpdatedUrl(plan.url));
        setDownloadUrl(plan.url);
      }
      if (plan.companyId === companyId && plan.sapDocumentId) {
        setSapDocumentId(plan.sapDocumentId);
      }
    });
  }, [generatedAccountPlans]);

  useEffect(() => {
    const profileSapId = (companyProfile as any)?.sapDocumentId;
    if (!sapDocumentId && profileSapId) {
      setSapDocumentId(profileSapId);
    }
  }, [sapDocumentId, companyProfile]);

  useEffect(() => {
    if (!sapDocumentId && latestHistoryId) {
      setSapDocumentId(latestHistoryId);
    }
  }, [sapDocumentId, latestHistoryId]);

  useEffect(() => {
    if (downloadAPIUrl && !drawerOpen && !isShareOperation) {
      const newWin = window.open(downloadAPIUrl);
      if (newWin) {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
    }
  }, [downloadAPIUrl]);

  useEffect(() => {
    if (isShareOperation && downloadAPIUrl) {
      document.getElementById('email-share-btn')?.click();
      setIsShareOperation(false);
    }
  }, [downloadAPIUrl]);

  const handlePlanDownload = () => {
    const documentId = sapDocumentId || latestHistoryId;
    if (!documentId) {
      dispatch(helperActions.setNotification({
        message: 'Please wait while we fetch your account plan information.',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      return;
    }
    setIsShareOperation(false);
    dispatch(actions.getDocumentDownloadURL({ id: documentId }));
    dispatch(helperActions.callFlurryEvent(
      valueToObject('download_account_plan', startTime, {}),
    ));
  };

  const handleShare = () => {
    const documentId = sapDocumentId || latestHistoryId;
    if (!documentId) {
      dispatch(helperActions.setNotification({
        message: 'Please wait while we fetch your account plan information.',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      return;
    }
    setIsShareOperation(true);
    dispatch(actions.getDocumentDownloadURL({ id: documentId }));
    dispatch(helperActions.callFlurryEvent(
      valueToObject('share_account_plan', startTime, {}),
    ));
  };

  const handlePreview = () => {
    const documentId = sapDocumentId || latestHistoryId;
    if (!documentId) {
      dispatch(helperActions.setNotification({
        message: 'Please wait while we fetch your account plan information.',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      return;
    }
    setIsShareOperation(false);
    dispatch(actions.getDocumentDownloadURL({ id: documentId }));
    setDrawerOpen(true);
    dispatch(helperActions.callFlurryEvent(
      valueToObject('accountPlan_clicked_previewFile', startTime, {}),
    ));
  };

  // useEffect(() => () => {
  //   dispatch(actions.setShowSAPHistory(false));
  // }, []);

  return (
    <Wrapper className={classNames('smart-account-plan-document-ready', { smartHistoryStyle: showAccountReadyScreen })}>
      <SmartPlanSvg color={primaryColor} />
      <h1 className="smart-document-heading">
        Your Smart Account Plan
        <sup>TM</sup>
        <br />
        is ready
      </h1>
      <div className="smart-btn-div">
        <div className="smart-btn">
          <span
            tabIndex={0}
            role="button"
            onClick={handleShare}
            onKeyPress={handleShare}
            className="share-btn-smart"
          >
            <ShareIcon color={primaryColor} />
            Share
          </span>
        </div>
        {downloadAPIUrl && (
          <EmailShareButton
            id="email-share-btn"
            className="social-icons-slide-mail smart-btn"
            url={downloadAPIUrl}
            subject="Smart Account Plan"
            separator="\r\n\r\n"
            style={{ display: 'none' }}
          >
            <span />
          </EmailShareButton>
        )}
        {!isTab ? (
          <>
            <Divider type="vertical" />
            <span
              tabIndex={0}
              role="button"
              className="smart-btn preview"
              onClick={handlePreview}
              onKeyPress={handlePreview}
            >
              <PreviewDocIcon />
              Preview
            </span>
          </>
        ) : null}
      </div>
      <span
        tabIndex={0}
        role="button"
        className="download-btn"
        onClick={handlePlanDownload}
        onKeyPress={handlePlanDownload}
      >
        <SaveIcon color="#fff" />
        Download
      </span>
      <CreateNewSapBtn companyId={companyId} handleAllowPop={handleAllowPop} />
      <SmartModal
        getContainer={() => document.querySelector('.smart-account-plan-document-ready') || document.body}
        visible={showPopup}
        onOk={handleNewAccountPlan}
        onCancel={() => setShowPopup(!showPopup)}
        centered
        cancelText="Cancel"
        okText="Yes"
        width={isSmMob ? '300px' : '406px'}
      >
        <GilroyWhiteSvg />
        <h1 className="popup-heading">{`${SMART_POPUP_TITLE}${companyProfile?.companyName || ''}?`}</h1>
      </SmartModal>
      <Preview
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        URL={previewAPIUrl}
      />
    </Wrapper>
  );
};
SmartPlanDocumentReady.defaultProps = defaultProps;
export default SmartPlanDocumentReady;